import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';

import { IWasteTreatment } from '../../pages/product-details/components/product-tab-view/tabs/pcf-tab/components/pcf-wizard/PcfWizard.type';
import AmplifyApiService from '../../services/AmplifyApiService';
import IAmplifyApiConfig from '../../shared/interfaces/IAmplifyApiConfig';
//
const amplifyApiService = new AmplifyApiService();

const BASE_PATH = 'waste-treatments';

// Hook for getting waste treatments
export const useListWasteTreatments = (
  options: UseQueryOptions<IWasteTreatment[], Error> = {},
): UseQueryResult<IWasteTreatment[]> => {
  const amplifyApiConfig: IAmplifyApiConfig = {
    apiName: 'PacificApi',
    path: BASE_PATH,
  };

  const query = useQuery<IWasteTreatment[], Error>({
    queryKey: [BASE_PATH],
    queryFn: async (): Promise<IWasteTreatment[]> => {
      const response = await amplifyApiService.get<IWasteTreatment[]>(amplifyApiConfig);

      return response;
    },
    ...options,
  });

  return query;
};
